const formatLocalDate = (value: Date): string => {
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, "0");
  const day = String(value.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

const localDateKey = (value: Date | string | null | undefined): string => {
  if (!value) return "";

  if (typeof value === "string") {
    return value.slice(0, 10);
  }

  return formatLocalDate(value);
};

export default localDateKey;
